import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubmitButtonComponent } from './submit-button/submit-button.component';
import { FormInputComponent } from './form-input/form-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormTextareaComponent } from './form-textarea/form-textarea.component';
import { FormCheckboxComponent } from './form-checkbox/form-checkbox.component';
import { FormRadioComponent } from './form-radio/form-radio.component';
import { FormCheckboxesComponent } from './form-checkboxes/form-checkboxes.component';
import { FormCheckboxesMapComponent } from './form-checkboxes-map/form-checkboxes-map.component';
import { FormRangeComponent } from './form-range/form-range.component';
import { FormSelectComponent, FormSelectService } from './form-select/form-select.component';
import { FormSelectMapComponent } from './form-select-map/form-select-map.component';
import { FormAutocompleteComponent } from './form-autocomplete/form-autocomplete.component';
// import { FormEditorComponent } from './form-editor/form-editor.component';
import { FormFactoryComponent } from './form-factory/form-factory.component';
// import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { FormFileComponent } from './form-file/form-file.component';
import { FormInputDateAmComponent } from './form-input-date-am/form-input-date-am.component';
import { FormComponent } from './form.component';
import { FormCheckboxesDropdownComponent } from './form-checkboxes-dropdown/form-checkboxes-dropdown.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // FroalaEditorModule.forRoot(),
    // FroalaViewModule.forRoot()
  ],
  exports: [
    SubmitButtonComponent,
  	FormInputComponent,
  	FormTextareaComponent,
  	FormCheckboxComponent,
  	FormRadioComponent,
  	FormCheckboxesComponent,
    FormCheckboxesMapComponent,
  	FormSelectComponent,
    FormSelectMapComponent,
    FormAutocompleteComponent,
    // FormEditorComponent,
    FormFactoryComponent,
    FormFileComponent,
    FormRangeComponent,
    FormInputDateAmComponent,
    FormComponent
  ],
  declarations: [
    SubmitButtonComponent,
  	FormInputComponent,
  	FormTextareaComponent,
  	FormCheckboxComponent,
  	FormRadioComponent,
  	FormCheckboxesComponent,
    FormCheckboxesMapComponent,
  	FormSelectComponent,
    FormSelectMapComponent,
  	FormAutocompleteComponent,
    // FormEditorComponent,
  	FormFactoryComponent,
  	FormFileComponent,
    FormRangeComponent,
    FormInputDateAmComponent,
    FormComponent,
    FormCheckboxesDropdownComponent
  ],
  providers: [
    FormSelectService,
  ]
})
export class VQFormsModule { }



// WEBPACK FOOTER //
// ./src/app/vqforms/vqforms.module.ts